/* eslint-disable quotes */
import { Component } from '@angular/core';
import { TableActionsTemplate } from 'src/app/@amiga-pyme/table-actions/templates/table-actions.template';
import { IEventAction } from 'src/app/@amiga-pyme/table-actions/components/ami-table-actions/ami-table-actions.interface';
import { PurchaseOrderReceptionService } from './purchase-order-reception.service';
import {
  IPurchaseOrderReception,
  PURCHASE_ORDER_RECEPTION_TTL_ES
} from './purchase-order-reception.interface';
import { MessageService } from 'primeng/api';
import { PurchaseOrderService } from '../purchase-order/purchase-order.service';

@Component({
  selector: 'pg-purchase-order-reception',
  templateUrl: './purchase-order-reception.component.html',
  providers: [MessageService]
})
export class PurchaseOrderReceptionComponent extends TableActionsTemplate {
  idDocument: number;
  showOpenPurchaseOrderReceptionCreate = false;
  confirmSettings = {};
  dataDocument: any;
  dataPurchaseOrder: any;
  purchaseOrderFiltered: any;
  accumulatedQuantity: number;
  orderedQuantity: number;
  constructor(
    private serviceBase: PurchaseOrderReceptionService,
    private purchaseOrderService: PurchaseOrderService,
    private messageService: MessageService
  ) {
    super('', serviceBase);
  }
  ngOnInit(): void {
    this.table.settings = {
      title: PURCHASE_ORDER_RECEPTION_TTL_ES,
      columns: [
        {
          header: 'Doc. Orden de Compra',
          field: 'numberDocumentPurchaseOrder'
        },
        {
          header: 'Doc. Recepción',
          field: 'numberDocument'
        },
        { header: 'Fecha de Recepción', field: 'reception_at', pipe: 'Date' }
      ]
    };
    this.table.actionsHead = [
      {
        name: 'create',
        icon: 'pi pi-plus',
        class: 'p-button-rounded p-button-primary',
        pTooltip: 'Registrar Recepción de Orden de Compra'
      }
    ];
    this.table.actions = [
      // {
      //   name: 'edit',
      //   icon: 'pi pi-pencil',
      //   class: 'p-button-rounded p-button-warning',
      //   pTooltip: 'Actualizar Recepción de Orden de Compra'
      // },
      {
        name: 'see-details',
        icon: 'pi pi-eye',
        class: 'p-button-rounded p-button-primary',
        pTooltip: 'Ver detalles'
      },
      {
        name: 'delete',
        icon: 'pi pi-trash',
        class: 'p-button-rounded p-button-danger',
        pTooltip: 'Eliminar Recepción'
      }
    ];
    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.purchaseOrderService
      .getData$()
      .subscribe((data: []) => {
        this.dataPurchaseOrder = data;
      });
    this.suscriptionBase$ = this.serviceBase
      .getData$()
      .subscribe((data: IPurchaseOrderReception[]) => {
        this.table.data = data;
      });
  }
  onReciveAction(event: IEventAction): void {
    const { data, action } = event;
    if (action === 'see-details') {
      this.dataDocument = data;
    }
    if (action === 'delete') {
      if (data.orderStatusId != 5) {
        this.confirmSettings = {
          message: 'Eliminar Recepción',
          action: 'delete',
          data
        };
      } else {
        this.messageService.add({
          severity: 'warn',
          summary: 'Orden de compra ha sido completada',
          detail: 'No está permitido eliminar una recepción.'
        });
      }
    }
  }

  onReciveActionHead(event: IEventAction): void {
    if (event) {
      const { action, data } = event;
      if (action === 'create') {
        this.showOpenPurchaseOrderReceptionCreate = true;
      }
    }
  }

  async actionConfirmed(event) {
    const { action, data } = event;
    if (action == 'delete') {
      this.message = { message: 'Eliminando recepción...' };
      this.updatePurchaseOrder(data);

      this.message = await this.serviceBase.delete(data.id);
      this.serviceBase.delete(data.id);
    }
  }

  updatePurchaseOrder(data) {
    this.purchaseOrderFiltered = [];
    this.purchaseOrderFiltered = this.dataPurchaseOrder.filter(
      (row) => row['id'] === data.purchaseOrderDocumentId
    );
    for (const product of data.products) {
      const id = this.purchaseOrderFiltered[0].products.findIndex(
        (item) => item['id'] == product['purchaseOrderDetailId']
      );

      this.purchaseOrderFiltered[0].products[id].quantity_received -=
        product.quantity;
    }
    this.accumulatedQuantity = 0;
    this.orderedQuantity = 0;
    for (const i in this.purchaseOrderFiltered[0].products) {
      this.accumulatedQuantity +=
        this.purchaseOrderFiltered[0].products[i].quantity_received;
    }
    if (this.accumulatedQuantity == 0) {
      this.purchaseOrderFiltered[0].receptionStatusId = 1;
    } else {
      this.purchaseOrderFiltered[0].receptionStatusId = 2;
    }

    const fieldsToUpdate = {
      document: {
        providerId: this.purchaseOrderFiltered[0].providerId,
        paymentTermsId: this.purchaseOrderFiltered[0].paymentTermsId,
        taxId: this.purchaseOrderFiltered[0].taxId,
        orderStatusId: this.purchaseOrderFiltered[0].orderStatusId,
        receptionStatusId: this.purchaseOrderFiltered[0].receptionStatusId,
        invoiceStatusId: this.purchaseOrderFiltered[0].invoiceStatusId,
        delivery_at: this.purchaseOrderFiltered[0].delivery_at,
        numberDocument: this.purchaseOrderFiltered[0].numberDocument
      },
      products: this.purchaseOrderFiltered[0].products
    };

    this.purchaseOrderService.update(
      this.purchaseOrderFiltered[0].id,
      fieldsToUpdate
    );
  }
  ngOnDestroy() {
    this.unsubscribeBase();
  }
}
